// BEGIN sps4ScenesGallery20260716
;(function sps4ScenesGallery20260716() {
  var config = {
  "handle": "copy-of-seibertron-youth-sps-4-winter-cold-weather-motorcycle-gloves-rainproof-riding-with-touchscreen-warm-gauntlet-for-boys-and-girls",
  "entries": [
    {
      "id": "33455413657790",
      "color": "Black",
      "role": "white-background-main",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-black-white-background-main-20260716.jpg?v=1784180684",
      "alt": "color:Black | batch:sps4-scenes-20260716 | role:white-background-main | Seibertron SPS-4 winter rainproof motorcycle gloves black white background main image"
    },
    {
      "id": "33455413690558",
      "color": "Black",
      "role": "scene-01",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-black-scene-01-20260716.jpg?v=1784180684",
      "alt": "color:Black | batch:sps4-scenes-20260716 | role:scene-01 | Seibertron SPS-4 winter rainproof motorcycle gloves black riding scene 01"
    },
    {
      "id": "33455413723326",
      "color": "Black",
      "role": "scene-02",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-black-scene-02-20260716.jpg?v=1784180684",
      "alt": "color:Black | batch:sps4-scenes-20260716 | role:scene-02 | Seibertron SPS-4 winter rainproof motorcycle gloves black riding scene 02"
    },
    {
      "id": "33455413756094",
      "color": "Black",
      "role": "scene-03",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-black-scene-03-20260716.jpg?v=1784180684",
      "alt": "color:Black | batch:sps4-scenes-20260716 | role:scene-03 | Seibertron SPS-4 winter rainproof motorcycle gloves black riding scene 03"
    },
    {
      "id": "33455413788862",
      "color": "Black",
      "role": "scene-04",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-black-scene-04-20260716.jpg?v=1784180684",
      "alt": "color:Black | batch:sps4-scenes-20260716 | role:scene-04 | Seibertron SPS-4 winter rainproof motorcycle gloves black riding scene 04"
    },
    {
      "id": "33455413821630",
      "color": "Black",
      "role": "scene-05",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-black-scene-05-20260716.jpg?v=1784180684",
      "alt": "color:Black | batch:sps4-scenes-20260716 | role:scene-05 | Seibertron SPS-4 winter rainproof motorcycle gloves black riding scene 05"
    },
    {
      "id": "33455413854398",
      "color": "White",
      "role": "white-background-main",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-white-white-background-main-20260716.jpg?v=1784180684",
      "alt": "color:White | batch:sps4-scenes-20260716 | role:white-background-main | Seibertron SPS-4 winter rainproof motorcycle gloves white white background main image"
    },
    {
      "id": "33455413887166",
      "color": "White",
      "role": "scene-01",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-white-scene-01-20260716.jpg?v=1784180684",
      "alt": "color:White | batch:sps4-scenes-20260716 | role:scene-01 | Seibertron SPS-4 winter rainproof motorcycle gloves white riding scene 01"
    },
    {
      "id": "33455413919934",
      "color": "White",
      "role": "scene-02",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-white-scene-02-20260716.jpg?v=1784180684",
      "alt": "color:White | batch:sps4-scenes-20260716 | role:scene-02 | Seibertron SPS-4 winter rainproof motorcycle gloves white riding scene 02"
    },
    {
      "id": "33455413952702",
      "color": "White",
      "role": "scene-03",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-white-scene-03-20260716.jpg?v=1784180684",
      "alt": "color:White | batch:sps4-scenes-20260716 | role:scene-03 | Seibertron SPS-4 winter rainproof motorcycle gloves white riding scene 03"
    },
    {
      "id": "33455413985470",
      "color": "White",
      "role": "scene-04",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-white-scene-04-20260716.jpg?v=1784180684",
      "alt": "color:White | batch:sps4-scenes-20260716 | role:scene-04 | Seibertron SPS-4 winter rainproof motorcycle gloves white riding scene 04"
    },
    {
      "id": "33455414018238",
      "color": "White",
      "role": "scene-05",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-white-scene-05-20260716.jpg?v=1784180684",
      "alt": "color:White | batch:sps4-scenes-20260716 | role:scene-05 | Seibertron SPS-4 winter rainproof motorcycle gloves white riding scene 05"
    },
    {
      "id": "33455414051006",
      "color": "Grey",
      "role": "white-background-main",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-grey-white-background-main-20260716.jpg?v=1784180684",
      "alt": "color:Grey | batch:sps4-scenes-20260716 | role:white-background-main | Seibertron SPS-4 winter rainproof motorcycle gloves grey white background main image"
    },
    {
      "id": "33455414083774",
      "color": "Grey",
      "role": "scene-01",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-grey-scene-01-20260716.jpg?v=1784180684",
      "alt": "color:Grey | batch:sps4-scenes-20260716 | role:scene-01 | Seibertron SPS-4 winter rainproof motorcycle gloves grey riding scene 01"
    },
    {
      "id": "33455414116542",
      "color": "Grey",
      "role": "scene-02",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-grey-scene-02-20260716.jpg?v=1784180684",
      "alt": "color:Grey | batch:sps4-scenes-20260716 | role:scene-02 | Seibertron SPS-4 winter rainproof motorcycle gloves grey riding scene 02"
    },
    {
      "id": "33455414149310",
      "color": "Grey",
      "role": "scene-03",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-grey-scene-03-20260716.jpg?v=1784180684",
      "alt": "color:Grey | batch:sps4-scenes-20260716 | role:scene-03 | Seibertron SPS-4 winter rainproof motorcycle gloves grey riding scene 03"
    },
    {
      "id": "33455414182078",
      "color": "Grey",
      "role": "scene-04",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-grey-scene-04-20260716.jpg?v=1784180684",
      "alt": "color:Grey | batch:sps4-scenes-20260716 | role:scene-04 | Seibertron SPS-4 winter rainproof motorcycle gloves grey riding scene 04"
    },
    {
      "id": "33455414214846",
      "color": "Grey",
      "role": "scene-05",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-grey-scene-05-20260716.jpg?v=1784180684",
      "alt": "color:Grey | batch:sps4-scenes-20260716 | role:scene-05 | Seibertron SPS-4 winter rainproof motorcycle gloves grey riding scene 05"
    },
    {
      "id": "33455414247614",
      "color": "Pink",
      "role": "white-background-main",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-pink-white-background-main-20260716.jpg?v=1784180684",
      "alt": "color:Pink | batch:sps4-scenes-20260716 | role:white-background-main | Seibertron SPS-4 winter rainproof motorcycle gloves pink white background main image"
    },
    {
      "id": "33455414280382",
      "color": "Pink",
      "role": "scene-01",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-pink-scene-01-20260716.jpg?v=1784180684",
      "alt": "color:Pink | batch:sps4-scenes-20260716 | role:scene-01 | Seibertron SPS-4 winter rainproof motorcycle gloves pink riding scene 01"
    },
    {
      "id": "33455414313150",
      "color": "Pink",
      "role": "scene-02",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-pink-scene-02-20260716.jpg?v=1784180684",
      "alt": "color:Pink | batch:sps4-scenes-20260716 | role:scene-02 | Seibertron SPS-4 winter rainproof motorcycle gloves pink riding scene 02"
    },
    {
      "id": "33455414345918",
      "color": "Pink",
      "role": "scene-03",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-pink-scene-03-20260716.jpg?v=1784180684",
      "alt": "color:Pink | batch:sps4-scenes-20260716 | role:scene-03 | Seibertron SPS-4 winter rainproof motorcycle gloves pink riding scene 03"
    },
    {
      "id": "33455414378686",
      "color": "Pink",
      "role": "scene-04",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-pink-scene-04-20260716.jpg?v=1784180684",
      "alt": "color:Pink | batch:sps4-scenes-20260716 | role:scene-04 | Seibertron SPS-4 winter rainproof motorcycle gloves pink riding scene 04"
    },
    {
      "id": "33455414411454",
      "color": "Pink",
      "role": "scene-05",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-pink-scene-05-20260716.jpg?v=1784180684",
      "alt": "color:Pink | batch:sps4-scenes-20260716 | role:scene-05 | Seibertron SPS-4 winter rainproof motorcycle gloves pink riding scene 05"
    }
  ]
};
  var entries = config.entries || [];
  function scope() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function colorFieldset(root) {
    return Array.prototype.find.call(root.querySelectorAll('fieldset[data-auto-option-position]'), function (fieldset) {
      var legend = fieldset.querySelector('legend span');
      return String(legend && legend.textContent || '').trim().toLowerCase() === 'color';
    });
  }
  function selectedColor(root) {
    var fieldset = colorFieldset(root);
    var checked = fieldset && fieldset.querySelector('input[data-auto-option]:checked');
    return checked ? checked.value : entries[0].color;
  }
  function colorEntries(color) {
    return entries.filter(function (entry) { return entry.color === color; });
  }
  function mainEntry(color) {
    return colorEntries(color).find(function (entry) { return entry.role === 'white-background-main'; });
  }
  function setMain(root, entry) {
    var main = root.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || '';
  }
  function ensureThumb(root, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-sps4-gallery-20260716', 'true');
    thumb.setAttribute('data-sps4-color', entry.color);
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View ' + entry.color + ' image ' + String(index + 1));
    thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    if (thumb.dataset.sps4GalleryBound !== 'true') {
      thumb.dataset.sps4GalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(root, entry);
        root.querySelectorAll('[data-auto-thumb]').forEach(function (node) { node.classList.toggle('is-active', node === thumb); });
      });
    }
    return thumb;
  }
  function hydrateSwatches(root) {
    var fieldset = colorFieldset(root);
    if (!fieldset) return;
    fieldset.querySelectorAll('[data-auto-visual-option-value]').forEach(function (label) {
      var color = label.getAttribute('data-auto-visual-option-value') || label.getAttribute('data-auto-color-value') || '';
      var entry = mainEntry(color);
      var shell = label.querySelector('[data-auto-choice-label]');
      if (!entry || !shell) return;
      shell.dataset.display = color;
      shell.removeAttribute('style');
      shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(color) + '"><img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(color) + '" width="72" height="72" loading="lazy"></span><span class="auto-product__swatch-label">' + escapeHtml(color) + '</span>';
    });
  }
  function hydrate(root, forceMain) {
    var wrap = root.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    entries.forEach(function (entry, index) { ensureThumb(root, wrap, entry, index); });
    hydrateSwatches(root);
    var color = selectedColor(root);
    var allowed = {};
    colorEntries(color).forEach(function (entry) { allowed[String(entry.id)] = true; });
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      var show = !!allowed[String(thumb.getAttribute('data-media-id') || '')];
      thumb.hidden = !show;
      thumb.style.display = show ? '' : 'none';
      thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
    var selectedMain = mainEntry(color);
    var changedColor = root.dataset.sps4GalleryColor !== color;
    if (forceMain || changedColor) {
      setMain(root, selectedMain);
      root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) { thumb.classList.toggle('is-active', String(thumb.getAttribute('data-media-id')) === String(selectedMain && selectedMain.id)); });
    }
    root.dataset.sps4GalleryColor = color;
  }
  function run(forceMain) {
    var root = scope();
    if (!root) return;
    hydrate(root, !!forceMain);
    if (root.dataset.sps4ScenesGalleryBound === 'true') return;
    root.dataset.sps4ScenesGalleryBound = 'true';
    root.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[data-auto-option]')) return;
      var fieldset = event.target.closest('fieldset');
      var legend = fieldset && fieldset.querySelector('legend span');
      if (String(legend && legend.textContent || '').trim().toLowerCase() !== 'color') return;
      [0, 100, 300, 700, 1500].forEach(function (delay) { window.setTimeout(function () { run(true); }, delay); });
    });
  }
  run(true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(true); }, { once: true });
  var attempts = 0;
  var timer = window.setInterval(function () {
    attempts += 1;
    run(false);
    if (attempts >= 100) window.clearInterval(timer);
  }, 150);
})();
// END sps4ScenesGallery20260716
